/**
 * Copy do catalogo da PROVA (Specialty: Clinica Medica, Cirurgia Geral, GO, Pediatria,
 * Preventiva...) — o que a prova cobra.
 *
 * R12-04: na tela o catalogo se chamava "Especialidades" e colidia com a especialidade
 * medica do aluno (`objective.ts`, "Especialidade pretendida"). Passa a "Grandes areas"
 * so no texto: tabela `specialties`, endpoint `/admin/specialties` e a rota da SPA nao
 * mudam. Nome provisorio, a confirmar com o Otavio.
 */
export const EXAM_AREAS_COPY = {
  title: 'Grandes áreas',
  singular: 'Grande área',
  newLabel: 'Nova grande área',
  editLabel: 'Editar grande área',
  deleteTitle: 'Excluir grande área',
  loading: 'Carregando grandes áreas...',
  empty: 'Nenhuma grande área encontrada',
} as const
